/* Dermafusion premium effects v1.3 — 2026-05-14 — fix count-up decimal parsing */
(function(){
  'use strict';
  if (!('IntersectionObserver' in window)) {
    var els = document.querySelectorAll('.df-reveal');
    for (var i=0;i<els.length;i++) els[i].classList.add('df-reveal--visible');
    return;
  }

  /* Scroll reveal */
  var revealObserver = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting) {
        entry.target.classList.add('df-reveal--visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  document.querySelectorAll('.df-reveal').forEach(function(el){ revealObserver.observe(el); });

  /* Count-up for stat numbers — supports Italian thousands (1.000+) and decimals (4.9) */
  function parseNumber(numRaw){
    var parts = numRaw.split('.');
    if (parts.length === 1) {
      return numRaw.replace(',', '.');
    }
    var lastPart = parts[parts.length - 1];
    if (lastPart.length === 3 && /^\d{3}$/.test(lastPart)) {
      return parts.join('').replace(',', '.');
    }
    var decimal = parts.pop();
    return (parts.join('') + '.' + decimal).replace(',', '.');
  }

  function animateNumber(el){
    if (el.dataset.dfAnimated) return;
    el.dataset.dfAnimated = '1';
    var original = el.textContent.trim();
    var match = original.match(/^([\d.,]+)(.*)$/);
    if (!match) return;
    var numStr = parseNumber(match[1]);
    var target = parseFloat(numStr);
    if (isNaN(target)) return;
    var suffix = match[2];
    var isInteger = !numStr.includes('.');
    var decimals = isInteger ? 0 : (numStr.split('.')[1] || '').length;
    var startTime = null;
    var duration = 1800;
    function format(n){
      if (isInteger) return Math.round(n).toLocaleString('it-IT');
      return n.toFixed(decimals);
    }
    function tick(now){
      if (!startTime) startTime = now;
      var elapsed = now - startTime;
      var progress = Math.min(elapsed/duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = format(target * eased) + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    }
    el.textContent = format(0) + suffix;
    requestAnimationFrame(tick);
  }
  var countObserver = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting) {
        animateNumber(entry.target);
        countObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  document.querySelectorAll('.df-hero-pro__trust-num, .df-hero-par__trust-num, [data-df-count]').forEach(function(el){
    countObserver.observe(el);
  });

  /* PARALLAX handler */
  if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
  var heroSections = document.querySelectorAll('.df-hero-par');
  heroSections.forEach(function(hero){
    var layers = hero.querySelectorAll('[data-parallax]');
    if (!layers.length) return;
    var mouseX = 0, mouseY = 0;
    var rafScheduled = false;
    function update(){
      layers.forEach(function(el){
        var depth = parseFloat(el.dataset.parallax) || 0.1;
        var x = mouseX * 30 * depth;
        var y = mouseY * 20 * depth;
        el.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0)';
      });
      rafScheduled = false;
    }
    hero.addEventListener('mousemove', function(e){
      var rect = hero.getBoundingClientRect();
      mouseX = ((e.clientX - rect.left) / rect.width) - 0.5;
      mouseY = ((e.clientY - rect.top) / rect.height) - 0.5;
      if (!rafScheduled) {
        rafScheduled = true;
        requestAnimationFrame(update);
      }
    });
    hero.addEventListener('mouseleave', function(){
      mouseX = 0; mouseY = 0;
      if (!rafScheduled) {
        rafScheduled = true;
        requestAnimationFrame(update);
      }
    });
  });
})();
